import { Dispatch } from 'react';
import { HEADERS } from 'src/constants/headers';
import api from 'src/api/api';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_STORE_GROUPS } from '../constants/actions';
import { TStoreGroupActionTypes } from '../types';

/**
 * Will return all store groups sorted by name
 *
 * @param {Dispatch<TStoreGroupActionTypes>} dispatch
 */
export const getAllStoreGroups = async (
    dispatch: Dispatch<TStoreGroupActionTypes>
) => {
    dispatch({ type: SET_LOADING });
    try {
        const res = await api.get('/store-groups?sort=name', HEADERS());

        dispatch({
            type: GET_STORE_GROUPS,
            payload: res.data.data,
            count: res.data.pagination?.total,
        });
    } catch (error) {
        dispatch(handleError(error));
    }
};
